export function CodeInlineIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M14.962 5.275a1 1 0 00-1.923-.55l-4 14a1 1 0 101.923.55l4-14zm-7.337.944a1 1 0 01.156 1.406L4.28 12l3.5 4.375a1 1 0 01-1.562 1.25L2.232 12.64a.995.995 0 01-.137-1.066.995.995 0 01.137-.214l3.987-4.985a1 1 0 011.406-.156zm8.75 0a1 1 0 011.406.156l3.988 4.985A.993.993 0 0122 12a.996.996 0 01-.232.64l-3.987 4.985a1 1 0 11-1.562-1.25L19.72 12l-3.5-4.375a1 1 0 01.156-1.406z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}
